import type { ComponentProps } from "react";

export const ChevronRight = (props: ComponentProps<"svg">) => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<title>Arrow</title>
		<path d="M9 7L14 12L9 17" stroke="var(--svg-color, currentColor)" strokeWidth="1.5" />
	</svg>
);

export const ChevronLeft = (props: ComponentProps<"svg">) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		style={{
			transform: "rotate(180deg)",
		}}
		{...props}
	>
		<title>Arrow</title>
		<path d="M9 7L14 12L9 17" stroke="var(--svg-color, currentColor)" strokeWidth="1.5" />
	</svg>
);

export const Chevron = (props: ComponentProps<"svg">) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<title>Arrow</title>
		<path d="M17 9.5L12 14.5L7 9.5" stroke="var(--svg-color, currentColor)" strokeWidth="1.5" />
	</svg>
);
